import { render, staticRenderFns } from "./X.vue?vue&type=template&id=4b9e60bd"
import script from "./X.vue?vue&type=script&lang=ts"
export * from "./X.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports